var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-dashboard__wrap",attrs:{"data-component-name":_vm.$options.name}},[_c('TimeSheetForemanComponent')],1)}
var staticRenderFns = []

export { render, staticRenderFns }